/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_MANAGE_CLIENT,
  LOAD_MANAGE_CLIENT_SUCCESS,
  LOAD_MANAGE_CLIENT_ERROR,

  ADD_CRM,
  ADD_CRM_SUCCESS,
  ADD_CRM_ERROR,

  ADD_TEAM_ASSIGN,
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  ADD_PRODUCT_ASSIGN,
  ADD_PRODUCT_ASSIGN_SUCCESS,
  ADD_PRODUCT_ASSIGN_ERROR,

  LOAD_PRODUCTION_ASSIGN_HISTORY,
  LOAD_PRODUCTION_ASSIGN_HISTORY_SUCCESS,
  LOAD_PRODUCTION_ASSIGN_HISTORY_ERROR,

  ADD_CLEARANCE,
  ADD_CLEARANCE_SUCCESS,
  ADD_CLEARANCE_ERROR,

  CRM_RESET,

  ADD_UNASSIGN,
  ADD_UNASSIGN_SUCCESS,
  ADD_UNASSIGN_ERROR,
  UPDATE_DATA,
  UPDATE_DATA_SUCCESS,
  UPDATE_DATA_ERROR,

  UPDATE_PROCESS,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_ERROR,

  ASSIGN_PRINTPL,
  ASSIGN_PRINTPL_SUCCESS,
  ASSIGN_PRINTPL_ERROR,

  LOAD_MAIN_EVENT,
  LOAD_MAIN_EVENT_SUCCESS,
  LOAD_MAIN_EVENT_ERROR,

  UPDATE_MAIN_EVENT,
  UPDATE_MAIN_EVENT_SUCCESS,
  UPDATE_MAIN_EVENT_ERROR,

  UPDATE_DORMANT,
  UPDATE_DORMANT_SUCCESS,
  UPDATE_DORMANT_ERROR,

  UPDATE_ESCALATION,
  UPDATE_ESCALATION_SUCCESS,
  UPDATE_ESCALATION_ERROR,


  
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


//permission list
export function loadCrmManageClient(searchvalue) {
  return {
    type: LOAD_MANAGE_CLIENT,
    searchvalue,
  }
}
export function loadCrmManageClientSuccess(crmManageClient_details) {
  return {
    type: LOAD_MANAGE_CLIENT_SUCCESS,
     crmManageClient_details,
  }
}
export function loadCrmManageClientError(error) {
  return {
    type: LOAD_MANAGE_CLIENT_ERROR,
    error,
  }
}

//add crm

export function addCrmAssign(crm_details){
  return{
    type:ADD_CRM,
    crm_details
  }
}
export function addCrmAssignSuccess(crmSuccess) {
  return {
    type: ADD_CRM_SUCCESS,
  crmSuccess
  }
}
export function addCrmAssignError(crmError) {
  return {
    TYPE:ADD_CRM_ERROR,
    crmError,
  }
}

export function addTeamAssign(team_details) {
  return {
    type: ADD_TEAM_ASSIGN,
    team_details,
  }
}

export function addTeamAssignSuccess(team_details) {
  return {
    type: ADD_TEAM_ASSIGN_SUCCESS,
    team_details
    
  }
}


export function addTeamAssignError(error) {
  return {
    type: ADD_TEAM_ASSIGN_ERROR,
    error,
  }
}

export function addProductAssign(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN,
    product_details,
  }
}

export function addProductAssignSuccess(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN_SUCCESS,
    product_details
    
  }
}


export function addProductAssignError(error) {
  return {
    type: ADD_PRODUCT_ASSIGN_ERROR,
    error,
  }
}

//PRODUCTION ASSIGN HISTORY
export function loadProductionAssignHistory(historyPayload) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY,
    historyPayload,
  }
}
export function loadProductionAssignHistorySuccess(history_details) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY_SUCCESS,
     history_details,
  }
}
export function loadProductionAssignHistoryError(error) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY_ERROR,
    error,
  }
}

export function crmReset() {
  return {
    type:CRM_RESET,
  }
}

//add clearance

export function addClearance(applyClearance) {
  return {
    type: ADD_CLEARANCE,
    applyClearance,
  }
}
export function addClearanceSuccess(crmSuccess) {
  return {
    type: ADD_CLEARANCE_SUCCESS,
    crmSuccess,
  }
}
export function addClearanceError(crmError) {
  return {
    TYPE: ADD_CLEARANCE_ERROR,
    crmError,
  }
}

//UNASSIGN

export function addUnassign(unAssign_data) {
  return {
    type: ADD_UNASSIGN,
    unAssign_data,
  }
}
export function addUnassignSuccess(crmSuccess) {
  return {
    type: ADD_UNASSIGN_SUCCESS,
    crmSuccess,
  }
}
export function addUnassignError(crmError) {
  return {
    TYPE: ADD_UNASSIGN_ERROR,
    crmError,
  }
}
//UPDATE DATA

export function updateData(dataDetails) {
  return {
    type: UPDATE_DATA,
    dataDetails,
  }
}
export function updateDataSuccess(dataDetails) {
  return {
    type: UPDATE_DATA_SUCCESS,
    dataDetails,
  }
}
export function updateDataError(error) {
  return {
    TYPE: UPDATE_DATA_ERROR,
    error,
  }
}

export function updateProcess(submitStatus) {
  return {
    type:UPDATE_PROCESS,
    submitStatus,
  }
}

export function updateProcessSuccess() {
  return {
    type: UPDATE_PROCESS_SUCCESS,
  }
}


export function updateProcessError(error) {
  return {
    type: UPDATE_PROCESS_ERROR,
    error,
  }
}
export function assignPrintPl(print_details) {
  return {
    type: ASSIGN_PRINTPL,
    print_details,
  }
}

export function assignPrintPlSuccess(print_details) {
  return {
    type: ASSIGN_PRINTPL_SUCCESS,
    print_details
    
  }
}


export function assignPrintPlError(error) {
  return {
    type: ASSIGN_PRINTPL_ERROR,
    error,
  }
}
//loadMainEvent
export function loadMainEvent(eventDetails) {
  return {
    type: LOAD_MAIN_EVENT,
    eventDetails,
  }
}
export function loadMainEventSuccess(mainEvent_data) {
  return {
    type: LOAD_MAIN_EVENT_SUCCESS,
     mainEvent_data,
  }
}
export function loadMainEventError(error) {
  return {
    type: LOAD_MAIN_EVENT_ERROR,
    error,
  }
}

export function updateMainEvent(update_event) {
  return {
    type:  UPDATE_MAIN_EVENT,
    update_event,
  }
}
export function updateMainEventSuccess(dataDetails) {
  return {
    type:  UPDATE_MAIN_EVENT_SUCCESS,
    dataDetails,
  }
}
export function updateMainEventError(error) {
  return {
    TYPE:  UPDATE_MAIN_EVENT_ERROR,
    error,
  }
}
//updateDormant

export function updateDormant(dormant_details) {
  return {
    type: UPDATE_DORMANT,
    dormant_details,
  }
}
export function updateDormantSuccess(dataDetails) {
  return {
    type: UPDATE_DORMANT_SUCCESS,
    dataDetails,
  }
}
export function updateDormantError(error) {
  return {
    TYPE: UPDATE_DORMANT_ERROR,
    error,
  }
}
//updateEscalation

export function updateEscalation(escalation_details) {
  return {
    type: UPDATE_ESCALATION,
    escalation_details,
  }
}
export function updateEscalationSuccess(dataDetails) {
  return {
    type: UPDATE_ESCALATION_SUCCESS,
    dataDetails,
  }
}
export function updateEscalationError(error) {
  return {
    TYPE: UPDATE_ESCALATION_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,


  loadCrmManageClient,
  loadCrmManageClientSuccess,
  loadCrmManageClientError,

  addCrmAssign,
  addCrmAssignSuccess,
  addCrmAssignError,

  addTeamAssign,
  addTeamAssignSuccess,
  addTeamAssignError,

  addProductAssign,
  addProductAssignSuccess,
  addProductAssignError,

  loadProductionAssignHistory,
  loadProductionAssignHistorySuccess,
  loadProductionAssignHistoryError,

  addClearance,
  addClearanceSuccess,
  addClearanceError,
  crmReset,

  addUnassign,
  addUnassignSuccess,
  addUnassignError,
  
  updateDataSuccess,
  updateData,
  updateDataError,
  updateProcess,
  updateProcessError,
  updateProcessSuccess,

  assignPrintPl,
  assignPrintPlSuccess,
  assignPrintPlError,

  loadMainEvent,
  loadMainEventSuccess,
  loadMainEventError,

  updateMainEvent,
  updateMainEventSuccess,
  updateMainEventError,

  updateDormant,
  updateDormantSuccess,
  updateDormantError, 

 

  updateEscalation,
  updateEscalationError,
  updateEscalationSuccess

}

export default actions
